import * as React from 'react';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { showPivotEnableDisableDialog } from '../actions/publicActions';
import { keyframes, AnimationVariables } from 'office-ui-fabric-react/lib/Styling';
import { observer } from 'mobx-react';
import {
    inboxPlusLightningCalloutTitle,
    inboxPlusLightningCalloutDescription,
    inboxPlusLightningCalloutGotIt,
} from './InboxPlusFirstRunCallout.locstring.json';
import { inboxPlusCustomize } from 'owa-locstrings/lib/strings/inboxPlusCustomize.locstring.json';
import loc from 'owa-localize';

export interface InboxPlusFirstRunCalloutProps extends LightningProps {
    target: () => HTMLElement;
}

@observer
@lightable
export default class InboxPlusFirstRunCallout extends React.Component<
    InboxPlusFirstRunCalloutProps,
    {}
> {
    render() {
        const tryItButtonProps: IButtonProps = {
            children: loc(inboxPlusLightningCalloutGotIt),
            onClick: this.onClose,
        };
        const dismissButtonProps: IButtonProps = {
            children: loc(inboxPlusCustomize),
            onClick: () => showPivotEnableDisableDialog(),
        };

        //TODO: VSO 40597 -- Inbox Plus Loc strings
        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    directionalHint: DirectionalHint.bottomCenter,
                }}
                targetElement={this.props.target()}
                onDismiss={this.onClose}
                hasSmallHeadline={true}
                headline={loc(inboxPlusLightningCalloutTitle)}
                primaryButtonProps={dismissButtonProps}
                secondaryButtonProps={tryItButtonProps}
                styles={{
                    subComponentStyles: {
                        callout: {
                            root: {
                                animationName: fade,
                            },
                        },
                    },
                    content: {
                        animationName: fade,
                    },
                }}>
                {loc(inboxPlusLightningCalloutDescription)}
            </TeachingBubble>
        );
    }

    private onClose = () => {
        lighted(this.props.lid);
    };
}

const fade: string = keyframes({
    '0%': {
        opacity: 0,
        animationTimingFunction: AnimationVariables.easeFunction2,
    },
    '26.26%': { opacity: 1 },
    '100%': { opacity: 1 },
});
